import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import styles from './dropdown.css';
var cx = classnames.bind(styles);
export default function DropdownSearchBox(_ref) {
  var bordered = _ref.bordered,
      onSearch = _ref.onSearch,
      placeholder = _ref.placeholder;
  return React.createElement("div", {
    className: styles.searchContainer
  }, React.createElement("input", {
    className: cx('searchInput', {
      bordered: bordered
    }),
    onChange: onSearch,
    placeholder: placeholder
  }), React.createElement(FontAwesomeIcon, {
    className: styles.icon,
    icon: faSearch
  }));
}
DropdownSearchBox.propTypes = {
  bordered: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};
DropdownSearchBox.defaultProps = {
  bordered: true,
  placeholder: 'Search...'
};